<template>
  <CRow sm="12">
    <CCol>
      <CCard>
        <CAlert v-if="alertMsg" :color="alertClr" fade>
          {{ alertMsg }}
        </CAlert>
        <CCol style="margin-top: 8px">
          <CButton
            color="info"
            @click="showModal"
            class="mr-1"
            v-if="hasMasterEditAuthority"
          >
            新規作成
          </CButton>
          <!-- TODO 一括削除未実装のためコメントアウト -->
          <!-- <CButton color="danger" @click="purge" class="mr-1">
            一括削除
          </CButton> -->
        </CCol>
        <CCardBody>
          <nobr>
            <CDataTable
              hover
              striped
              clickable-rows
              :items="items"
              :fields="fields"
              :tableFilter="true"
              :sorter="true"
              :itemsPerPageSelect="true"
              :active-page="activePage"
              @row-clicked="rowClicked"
              :pagination="{
                doubleArrows: false,
                align: 'center',
                dots: false,
              }"
              @page-change="pageChange"
            >
              <!-- TODO 一括削除未実装のためコメントアウト -->
              <!-- <template #check="data">
                <td>
                  <CInputCheckbox v-on:click="checkbox($event)">
                    {{ data.item.check }}
                  </CInputCheckbox>
                </td>
              </template> -->
              <template #No="{ index }">
                <td>
                  {{ index + 1 }}
                </td>
              </template>
            </CDataTable>
          </nobr>
        </CCardBody>
        <PositionAddModal
          :visible="addModalVisible"
          @close="closeAddModal($event)"
        />
        <PositionEditModal
          :visible="editModalVisible"
          :data="inputItems"
          :index="index"
          :hasMasterEditAuthorityProp="hasMasterEditAuthority"
          @close="closeEditModal($event)"
        />
      </CCard>
    </CCol>
  </CRow>
</template>

<script>
import PositionAddModal from "./PositionAddModal";
import PositionEditModal from "./PositionEditModal";
import authorityControl from "../../../mixins/authorityControl";
import constPage from "../../../../definition/const/const_page";
import constOperationAuthority from "../../../../definition/const/const_operation_authority";

export default {
  name: "PositionMaster",
  mixins: [authorityControl],
  data() {
    return {
      items: [],
      fields: [
        // { key: "check", label: "" },//TODO 一括削除未実装のためコメントアウト
        { key: "No", label: "No." },
        { key: "position_name", label: "役職名" },
        { key: "position_number", label: "役職優位番号" },
      ],
      activePage: 1,
      alertMsg: "",
      alertClr: "",
      addModalVisible: false,
      editModalVisible: false,
      inputItems: {},
      index: 0,
    };
  },
  components: {
    PositionAddModal,
    PositionEditModal,
  },
  watch: {
    $route: {
      immediate: true,
      handler(route) {
        if (route.query && route.query.page) {
          this.activePage = Number(route.query.page);
        }
      },
    },
  },
  async mounted() {
    await this.fetchData();
  },
  methods: {
    rowClicked(item, index) {
      // クリックされた行のデータを更新モーダルに渡す
      this.inputItems = { ...item };
      this.index = index + 1;
      this.editModalVisible = true;
      // メッセージを非表示
      this.alertMsg = "";
    },
    pageChange(val) {
      this.$router.push({ query: { page: val } });
    },
    //TODO 一括削除未実装のためコメントアウト
    // checkbox: function (event) {
    //   if (event) {
    //     event.stopPropagation();
    //   }
    // },
    showModal() {
      this.addModalVisible = true;
      // メッセージを非表示
      this.alertMsg = "";
    },
    //TODO 一括削除未実装のためコメントアウト
    // purge() {
    //   if (!confirm("削除しますか")) {
    //     return;
    //   } else {
    //   }
    // },
    closeAddModal(result) {
      this.addModalVisible = false;
      // 表示アラート設定
      this.setAlert(result);
      //一覧更新
      this.fetchData();
    },
    closeEditModal(result) {
      this.editModalVisible = false;
      // 表示アラート設定
      this.setAlert(result);
      //一覧更新
      this.fetchData();
    },
    setAlert(altObj) {
      if (altObj) {
        this.alertClr = altObj.alertClr;
        this.alertMsg = altObj.alertMsg;
        // 画面上部までスクロールする
        window.scrollTo({
          top: 0,
          behavior: "smooth",
        });
      }
    },
    async fetchData() {
      await this.$axios
        .get("/api/v1/positions")
        .then((res) => {
          // console.log(res);
          this.items = res.data.positions;
        })
        .catch((e) => {
          console.error(e.response.data.message);
        });
    },
  },
  computed: {
    hasMasterEditAuthority: function () {
      return (
        this.getAuthorityId(constPage.POSITION_EDIT_MASTER) ===
        constOperationAuthority.EDIT_ALL
      );
    },
  },
};
</script>

<style scoped>
.srchbar {
  display: inline-block;
  border-radius: 25px;
  border: 1px solid;
  border-color: silver;
  margin-right: 10px;
  height: 40px;
  width: 200px;
}
</style>